// NDIS Audit Readiness Centre — UI access rules, state metadata and summary helpers (server remains authoritative).
import { libraryError } from '@/lib/libraryAccess';

export const canViewReadiness = (has) => has('readiness.view');
export const canManageReadiness = (has) => has('readiness.view') && has('readiness.manage');
export const canExportReadiness = (has) => has('readiness.view') && has('readiness.export');
export const readinessError = libraryError;

// Neutral states only. label + glyph carry meaning; tone is decorative.
export const STATE_META = {
  EVIDENCE_AVAILABLE: { label: 'Evidence available', glyph: '●', tone: 'done', order: 6 },
  REVIEW_DUE: { label: 'Review due', glyph: '◐', tone: 'warn', order: 4 },
  EVIDENCE_PARTIAL: { label: 'Evidence partial', glyph: '◑', tone: 'progress', order: 3 },
  EVIDENCE_MISSING: { label: 'Evidence missing', glyph: '○', tone: 'alert', order: 2 },
  EXPIRED: { label: 'Expired', glyph: '✕', tone: 'alert', order: 1 },
  NOT_ASSESSED: { label: 'Not assessed', glyph: '?', tone: 'muted', order: 5 },
  NOT_APPLICABLE: { label: 'Not applicable', glyph: '–', tone: 'muted', order: 7 },
};
export const STATES = Object.keys(STATE_META);
export const GAP_STATES = ['EXPIRED', 'EVIDENCE_MISSING', 'EVIDENCE_PARTIAL', 'REVIEW_DUE', 'NOT_ASSESSED'];
export const stateLabel = (s) => STATE_META[s]?.label || String(s || '—').replace(/_/g, ' ');

// Evidence coverage = outcomes with evidence available ÷ applicable outcomes (excludes NOT_APPLICABLE). Never a compliance figure.
export function coverage(byState = {}, total = 0) {
  const na = byState.NOT_APPLICABLE || 0; const applicable = Math.max(0, total - na);
  const available = byState.EVIDENCE_AVAILABLE || 0; const partial = (byState.EVIDENCE_PARTIAL || 0) + (byState.REVIEW_DUE || 0);
  return { applicable, available, partial, percent: applicable ? Math.round((available / applicable) * 100) : 0, partialPercent: applicable ? Math.round((partial / applicable) * 100) : 0 };
}

export const EVIDENCE_TYPE_LABEL = (t) => {
  const [kind, name] = t.split(':');
  const n = (name || '').replace(/_/g, ' ');
  return kind === 'form' ? `Form: ${n}` : kind === 'register' ? `Register: ${n}` : kind === 'source' ? `Module: ${n}` : kind === 'setting' ? `Setting: ${n}` : t;
};
export const SOURCE_LINK = (e) => {
  const k = e.kind; const id = e.ref_id;
  if (k === 'incident') return `/incidents/${id}`; if (k === 'document') return `/documents?id=${id}`; if (k === 'form_submission') return `/forms/submissions/${id}`;
  if (k === 'register_entry' && e.source?.startsWith('register:')) return `/audit/registers/${e.source.split(':')[1]}`;
  if (k === 'feedback') return `/engagement/feedback/${id}`; if (k === 'restrictive_practice') return `/restrictive-practices/${id}`;
  return null;
};
export const LINK_KINDS = ['document', 'form_submission', 'incident', 'feedback', 'restrictive_practice', 'risk_assessment', 'care_plan', 'service_agreement', 'register_entry', 'external'];
export const REGISTER_TYPES = ['risk', 'internal_audit', 'legislative', 'delegation', 'conflict_of_interest', 'hazardous_chemical', 'improvement'];
export const fmt = (v) => (v ? String(v).slice(0, 10) : '—');
